export default "__VITE_PUBLIC_ASSET__e0bfea1f__"